import { createContext } from 'react';

import { TooltipSingletonObject } from './types';

export const TooltipSingletonContext = createContext<
  TooltipSingletonObject | undefined
>(undefined);
